export class Tarifinformationen {
  produktId = "";
  produktbezeichnung = "";
  tarifVariante = "";
  produktLinie = "";
  selbstbeteiligung = 0;
  versicherungssumme: number | null;
  vorschaedenAnzahl = 0;
  hundehalterhaftpflicht = false;
  hausundgrundbesitzerhaftpflicht = false;
  elementar = false;
  glasschutz = false;
  vermieterplus = false;
  hausverwalterkonzept = false;
  rohbauversicherung = false;
  soforthilfe = false;
  fahrradschutz = false;
  photovoltaikModul = false;
  proklima = false;
  fahrradschutzProzent = 0;
  fahrradschutzBetrag = 0;
  extraSelbstbeteiligung = 0;
  extraSelbstbeteiligungLeitungswasser = 0;
  sfr = 0;
  buendelRabatt = false;
  winterdienstRabatt = false;
  hundeAnzahl = 0;
  hugMitglied = false;
  versicherungsbeginn = "";
  zahlungsweise = 1;
  abschlagZuschlag = "";
  abschlagZuschlagHoehe = 0;
  tariff60Plus = false;
  deckungssumme = 0;
  ablauf = "";
  kernsanierung = false;

  //Frontend-spezifische Erweiterungen
  beitragVorKernsanierungGemZahlungsweise = 0;
  beitragVorKernsanierungJaehrlich = 0;
  anpassungZahlungsweise = false;

  sfrAusVorbelegung = "";
  vemaKonzept = false;

  constructor() {
    this.versicherungssumme = 0;
  }
}
